import { ColWrap, Transition } from "components/shared/column";
import ErrorBoundary from "components/shared/errorBoundary";
import ScrollPositionContext from "contexts/scrollPosition";
import React, { Component } from "react";
import { Route } from "react-router-dom";
import Body from "./body";
import Chat from "./chat";

export default class BidShow extends Component {
    static contextType = ScrollPositionContext;
    state = { shouldUpdateBid: false, shouldUpdateChat: false };

    componentDidMount() {
        this.context.setPrevItemId(Number(this.props.match.params.id));
    }

    changeShouldUpdateBid = (value) => {
        this.setState({ shouldUpdateBid: value });
    };

    changeShouldUpdateChat = (value) => {
        this.setState({ shouldUpdateChat: value });
    };

    render() {
        const { history, baseUrl } = this.props;
        const toShow = () => history.push(baseUrl);
        const toChat = (chatId) => history.push(`${baseUrl}/chat/${chatId}`);
        return (
            <ColWrap>
                <Route
                    path={baseUrl}
                    render={() => (
                        <Transition {...this.props} dir="left" wrapper="page-col--overflow-inherit">
                            <ErrorBoundary>
                                <Body
                                    {...this.props}
                                    toChat={toChat}
                                    shouldUpdateBid={this.state.shouldUpdateBid}
                                    changeShouldUpdateBid={this.changeShouldUpdateBid}
                                    changeShouldUpdateChat={this.changeShouldUpdateChat}
                                />
                            </ErrorBoundary>
                        </Transition>
                    )}
                />
                <Route
                    path={`${baseUrl}/chat/:chatId`}
                    render={(props) => {
                        const chatProps = {
                            baseUrl,
                            back: toShow,
                            chatId: props.match.params.chatId,
                            changeShouldUpdateBid: this.changeShouldUpdateBid,
                            changeShouldUpdateChat: this.changeShouldUpdateChat,
                            shouldUpdateChat: this.state.shouldUpdateChat,
                        };
                        return (
                            <Transition {...props} dir="right">
                                <ErrorBoundary>
                                    <Chat {...chatProps} />
                                </ErrorBoundary>
                            </Transition>
                        );
                    }}
                />
            </ColWrap>
        );
    }
}
